export default function() {
    return new Promise(resolve => {

        this.loading = true;
        let form_data = new FormData;
        form_data.append('action', ajax_var.action_check_email);
        form_data.append('email', this.$refs.email.value);
        form_data.append('nonce', ajax_var.nonce);

        axios.post(ajax_var.url, form_data).then((res) => {
            this.initFloatingLabel();
            if (res.status == 200) {
                if (res.data != false) {
                    this.loading = false;
                    this.errorData.email = "Sorry, this email is already registered.";
                    resolve(false);
                } else {
                    this.errorData.email = "";
                    resolve(true);
                }
            } else {
                this.loading = false;
                this.errorData.email = "Sorry, something went wrong. Try again.";
                resolve(false);
            }
        })
            .catch(error => {
                this.loading = false;
                resolve(false);
                console.log(error);
            });

    });
};
